module.exports = __webpack_public_path__ + "static/media/mmume_07.ac3fd89b.png";